<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NamMXE/tc-custom/9781609254964.jpg?1718106504526" alt="This image is the cover for the book Meeting the Monkey Halfway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Meeting the Monkey Halfway
      </h1>
      <p class="bookDescription body article font2">
        <b>An American Buddhist monk in the Theravada tradition offers wisdom and spiritual practices on attaining mindful presence.</b><br/><br/>Simple and straightforward, this “little book” is a distillation of twenty years of a Buddhist monk’s meditation practice. With a sense of reverence and respect for everything, Ajahn Sumano Bhikkhu shows us how to use only what we need, and then to use these few things carefully and with discrimination. <i>Meeting the Monkey Halfway</i> is his personal story, and through his story he will help us to open our hearts and relearn the compassion of the Buddha.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ajahn Sumano Bhikkhu, Emily Popp
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Samuel Weiser, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f8c9790